module.exports = __webpack_public_path__ + "img/Capacitacao_em_Centro_Cirurgico.07fa5b62.jpg";